<template>
  <modal-form-helper :data="{...mdldata, title:'Contact'}" :form="post">
    <template #body>
      <div ref="field_defs" class="d-none">
        <!-- start -->
        <div ref="field_company">
          <form-select2
              :required="false"
              :disabled="id"
              name="company"
              label="Company"
              :form="post"
              v-model="post.company"
              :options="drdata.companies"
              :config="{
                          id: 'id',
                          label: 'name',
                          ajax: {
                            paginated: false,
                            url: genUrl('companies', null,  'search'),
                            term: 'name',
                          }
                        }"
              :classes="['form-select-solid form-select-sm']"


          >
          <template #labelText>Company<span><a class="ml-1 text-primary cursor-pointer"
                                                 @click="openModal('company_create', 'companies')"> (Add new)</a></span>
            </template>
          </form-select2>
        </div>

        <div ref="field_office">
          <form-select2
              :required="false"
              :disabled="!post.company"
              name="office"
              label="Office"
              :form="post"
              v-model="post.office"
              :options="drdata.office"
              :config="addr_search_config"
              :classes="['form-select-solid']"
          />
        </div>

        <div ref="field_title">
          <form-select2
              :required="false"
              name="title"
              label="Title"
              :form="post"
              v-model="post.title"
              :options="drdata.title"
              :config="{
                          id: 'id',
                          label: 'title',
                          ajax: {
                            paginated: false,
                            url: genUrl('user_title', null,  'get'),
                            term: 'title',
                          }
                        }"
              :classes="['form-select-solid']"
          />
        </div>

        <div ref="field_first_name">
          <form-input v-model="post.first_name" :form="post" name="first_name" label="First Name"
                      :debounce="true"
                      :required="false"
                      :debounce-settings="{url: genUrl('contact', null, 'search'), param: 'query', label: 'name', extra_params: {company: post.company}}"/>
        </div>

        <div ref="field_last_name">
          <form-input v-model="post.last_name" :required="false" :form="post" name="last_name" label="Last Name"
                      :debounce="true"
                      :debounce-settings="{url: genUrl('contact', null, 'search'), param: 'query', label: 'name', extra_params: {company: post.company}}"/>
        </div>

        <div ref="field_direct_mobile">
          <form-input v-model="post.direct_mobile" :required="false" :form="post" name="direct_mobile" label="Mobile Phone"/>
        </div>

        <div ref="field_direct_phone">
          <form-input v-model="post.direct_phone" :required="false" :form="post" name="direct_phone" label="Office Phone"/>
        </div>

        <div ref="field_email">
          <form-input v-model="post.email" :required="false" :form="post" name="email" label="Email"/>
        </div>

        <div ref="field_association">
          <form-input v-model="post.association" :required="false" :form="post" name="association" label="Association"/>
        </div>

        <div ref="field_job_title">
          <form-input v-model="post.job_title" :required="false" :form="post" name="job_title" label="Job title"/>
        </div>

        <div ref="field_nick_name">
          <form-input v-model="post.nick_name" :required="false" :form="post" name="nick_name" label="Nick Name"/>
        </div>
        <div ref="field_suffixes">
          <form-input v-model="post.suffixes" :required="false" :form="post" name="suffixes" label="Suffixes"/>
        </div>
        <div ref="field_assistant_name">
          <form-input v-model="post.assistant_name" :required="false" :form="post" name="assistant_name" label="Assistant Name"/>
        </div>
        <div ref="field_personal_email">
          <form-input v-model="post.personal_email" :required="false" :form="post" name="personal_email" label="Personal Email"/>
        </div>
        <div ref="field_home_phone">
          <form-input v-model="post.home_phone" :required="false" :form="post" name="home_phone" label="Home Phone"/>
        </div>

        <div ref="field_relationships">
          <form-select2
              :required="false"
              name="users"
              label="Relationship"
              placeholder=""
              :form="post"
              :template="userTemplate"
              :selection-template="userSelectionTemplate"
              v-model="post.users"
              :options="users"
              :config="{
                    id: 'id',
                    label: 'name',
                    multiple: true,
                    ajax: {
                      paginated: true,
                      url: genUrl('users', null,  'search'),
                      term: 'query',
                    }
                  }"
              :classes="['form-select-solid']"
          >
          </form-select2>
        </div>

        <!--Custom fields-->
        <div v-for="field in fields.custom_fields">
          <div :ref="`field_${field.field_key}`">
            <div v-if="field.field_type==='text'">
              <form-input :required="false" v-model="post[field.field_key]" :form="post"
                          :name="field.field_key" :label="field.title"/>
            </div>
            <div v-else-if="field.field_type==='long_text'">
              <form-input :required="false" v-model="post[field.field_key]" :form="post"
                          :name="field.field_key" :label="field.title"/>
            </div>
            <div v-else-if="field.field_type==='multiple_option'">
              <label class="align-items-center dm-fs-0-9-rem fw-bolder form-label">
                {{ field.title }}
              </label>
              <select2
                  :required="false"
                  v-model="post[field.field_key]"
                  :options="field.options"
                  :config="{
                              label: 'label',
                              multiple: true,
                            }"
              />
            </div>
            <div v-else-if="field.field_type==='single_option'">
              <label class="align-items-center dm-fs-0-9-rem fw-bolder form-label">
                {{ field.title }}
              </label>
              <select2
                  :required="false"
                  v-model="post[field.field_key]"
                  :options="field.options"
                  :config="{
                              label: 'label'
                            }"
              />
            </div>
            <div v-else-if="field.field_type==='date'" :id="`field_${field.field_key}`">
              <label class="align-items-center dm-fs-0-9-rem fw-bolder form-label d-flex">
                {{ field.title }}
              </label>
              <date-picker
                          :value="post[field.field_key]"
                          @input="(val) => setDateForce(field.field_key, val)"
                         :typeable="false"
                           input-class="form-control form-control-sm form-control-solid mb-3 w-100"
                           format="DD-MM-YYYY"/>
            </div>
            <has-error :form="post" :field="field.field_key"></has-error>
          </div>
        </div>
      </div>
      
      <div ref="fields_rend">
        <div v-for="section in sections">
          <h4 v-show="section.title_show">{{ section.title }}</h4>
          <div class="row" v-for="(col, colIndex) in Array.from({length: section.max_rows})">
            <div class="col-md-6" v-for="(dir, dirIndex) in section.directions">
              <div v-if="section.fields[dirIndex][colIndex]"
                   :ref="`rend_field_${section.fields[dirIndex][colIndex].field}`"></div>
            </div>
          </div>
        </div>
        
      </div>
    </template>
  </modal-form-helper>
</template>

<script>
import cm from "@mxn/create"
import get_custom_fields from './get_custom_fields'
import UserSelector from "@cc/includes/UserSelector.vue";
// import FieldComponent from "./FieldComponent.vue";
// import CDF from "./CustomDataFields.vue";

// import CompanyCreate from "@cc/clients/companies/CompanyCreate.vue"
import CompanyCreate from "@cc/modules/crm/company/CreateCompanyModal.vue";

export default {
  name: "AddPeopleModal",
  components: {UserSelector},
  mixins: [cm, get_custom_fields],
  props: {
    url_key: {
      default: 'peoples'
    },
    asModal: {default: true},
    // customFields: {default: []},
  },
  data() {
    return {
      form_category: 'person',
      id: null,
      isModal: true,

      searchingName: false,
      nameDuplicates: [],

      drdata: {
        companies: [],
        country_codes: [],
        title: [],
        ownerships: [],
        office: [],
        project: null,
      },
      // fields: this.customFields,
      users: [],
      users1:[],
      post: Form.make({
        company: '',
        office: '',
        email: '',
        title: '',
        first_name: '',
        last_name: '',
        job_title: '',
        direct_phone: '',
        direct_mobile: '',
        users: [],


        nick_name: '',
        suffixes: '',

        assistant_name: '',

        date_joined: '',
        date_left: '',

        dnc: '',
        left_company: '',
        withdrawn: '',

        personal_email: '',
        home_phone: '',
        
      }),
    };
  },
  watch: {
    // 'post.users': {
    //   handler(v, v1){
    //     debugger
    //   },
    //   deep: true
    // }
  },
  computed: {
    addr_search_config() {
      return {
        id: 'id',
        label: 'branch',
        ajax: {
          paginated: false,
          url: this.genUrl('office_address', null, 'get'),
          term: 'branch',
          params: {company: this.post.company}
        }
      }
    },

  },

  mounted() {
    let url = this.genUrl('peoples', null, 'custom_fields')
    this.getCustomFields(url)

    this.$root.$on("company_created_project", (data) => {
      if (data.id) {
        this.drdata.companies.push({name: data.name, id: data.id})

        this.post.update({
          ...this.post,
          company: data.id
        })
      }
    })
  },
  destroyed() {
    this.$root.$off("company_created_project")
  },
  methods: {
    postCreate(response){
      this.$root.$emit("contact_created", response)
    },
    edit(){},
    postRenderFields(){
      if(!this.record?.id){
        this.users = [this.$user]
        this.post.users = [this.$user.id]
        return
      }

      this.drdata.companies = [this.record.company]
      this.drdata.office = this.record.office ? [this.record.office]: []
      this.drdata.title = this.record.title ? [this.record.title]: []
      this.users = this.record.users
      console.log(this.users)
             
      this.post.update({
        ...this.record.custom,
        ...this.record,
        company: _.get(this.record.company, 'id'),
        office: _.get(this.record.office, 'id'),
        title: _.get(this.record.title, 'id'),
        users: this.users.map(u => u.id),   
      })
      // debugger
      // this.$forceUpdate()
      console.log("cus :: " + this.record.custom)
      // debugger
    },
    openModal(component, urlKey = null) {
      let component_ = ''
      switch (component) {
        case 'company_create':
          component_ = CompanyCreate
          break
        default:
          throw new Error("component type not in list")
      }

      this.$modal.show(
          component_,
          {
            urlKey,
          },
          {
            height: "auto",
            scrollable: true
          }
      );
    },
    
  },
}
</script>